<script lang="js">
import { RouterLink } from 'vue-router';

export default {
    name: 'QuickLinks',
    data() {
        return {}
    },
    methods: {},
    mounted() {},
    computed: {},
    components: {RouterLink},
    created: function () {}
}
</script>

<template>
  <div class="bg-light">
    <div class="fcp-bg-primary w-100 p-5 text-white">
      <h1>Quick Links</h1>
      <div class="yellow-dash"></div>
    </div>

    <div class="container text-center py-5">
      <div
        class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2 g-lg-3 mt-0 fw-bold fs-5"
      >
        <div class="col">
          <div class="p-3">
            <RouterLink
              :to="$urlHelper.getApplyPath()"
              class="link-offset-2 link-offset-3-hover link-dark link-underline-opacity-0 link-underline-opacity-75-hover"
            >
              <i class="bi bi-card-checklist me-2"></i>
              Online Application
            </RouterLink>
          </div>
        </div>
        <div class="col">
          <div class="p-3">
            <a
              @click="$urlHelper.goToPortal('/')"
              class="link-offset-2 link-offset-3-hover link-dark link-underline-opacity-0 link-underline-opacity-75-hover"
              style="cursor: pointer"
            >
              <i class="bi bi-person me-2"></i>
              Student Portal
            </a>
          </div>
        </div>
        <div class="col">
          <div class="p-3">
            <a
              class="link-offset-2 link-offset-3-hover link-dark link-underline-opacity-0 link-underline-opacity-75-hover"
              href="#"
            >
              <i class="bi bi-newspaper me-2"></i>

              Blogs
            </a>
          </div>
        </div>
        <div class="col">
          <div class="p-3">
            <a
              class="link-offset-2 link-offset-3-hover link-dark link-underline-opacity-0 link-underline-opacity-75-hover"
              href="https://onlineapp.firstcitypoly.edu.ng/Agents/"
            >
              <i class="bi bi-person-badge me-2"></i>

              Agent Login
            </a>
          </div>
        </div>
        <div class="col">
          <div class="p-3">
            <RouterLink
              class="link-offset-2 link-offset-3-hover link-dark link-underline-opacity-0 link-underline-opacity-75-hover"
              to="/funding"
            >
              <i class="bi bi-mortarboard me-2"></i>
              Scholarship
            </RouterLink>
          </div>
        </div>
        <div class="col">
          <div class="p-3">
            <a
              class="link-offset-2 link-offset-3-hover link-dark link-underline-opacity-0 link-underline-opacity-75-hover"
              href=""
            >
              <i class="bi bi-info-circle me-2"></i>

              FAQs
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped></style>
